var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCause5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    "data-name": "Calque 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #ff305e;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M80.31,64c0,13.8-1.99,29-11.37,29s-7.49-26.26-18.94-26.26-9.64,26.26-18.94,26.26-10.36-15.2-10.36-29S-.51,7,26.01,7c14.42,0,14.42,5.26,23.99,5.26s9.57-5.26,23.99-5.26c26.51,0,6.32,43.19,6.32,57Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCause5);
export default __webpack_public_path__ + "static/media/cause_5.e8a02fd964f60407ff04d4d0cc194343.svg";
export { ForwardRef as ReactComponent };